import { DATE_FORMAT } from '@app/constants/dates'
import _ from 'lodash'
import moment from 'moment'

export function formatDate (date, format = DATE_FORMAT.DAY_MONTH_YEAR_DASHED) {
  if (!date) return null
  return moment(date)
    .format(format)
    .toString()
}

export function getFormattedToday (format = DATE_FORMAT.DAY_MONTH_YEAR_DASHED) {
  return moment().format(format)
}

export const TIMEZONE = {
  ID: {
    name: 'Asia/Jakarta',
    offset: 7
  },
  SG: {
    name: 'Asia/Singapore',
    offset: 8
  },
  MY: {
    name: 'Asia/Kuala_Lumpur',
    offset: 8
  },
  TH: {
    name: 'Asia/Bangkok',
    offset: 7
  },
  VN: {
    name: 'Asia/Ho_Chi_Minh',
    offset: 7
  },
  PH: {
    name: 'Asia/Manila',
    offset: 8
  },
  MA: {
    name: 'Africa/Casablanca',
    offset: 1
  },
  MM: {
    name: 'Asia/Myanmar',
    offset: 6.5
  }
}

export const getTimezoneOffset = (tzString) => {
  const tz = _.find(TIMEZONE, TIMEZONE[_.toUpper(tzString)], TIMEZONE.SG)
  return tz.offset
}
